export default {"src":"/_next/static/media/popRight.6e083be2.svg","height":394,"width":394,"blurWidth":0,"blurHeight":0};